/**
 * Canonical invoice taxonomy display vocabulary (single source of truth
 * for the frontend). Mirrors backend/services/invoice_taxonomy.py's
 * VALID_SUPPLIER_TAXONOMIES / VALID_CLIENT_TAXONOMIES stored values --
 * this module maps those stored strings to display labels only, it never
 * changes what gets persisted (db.invoices.taxonomy,
 * counterparty_taxonomy_mappings.taxonomy are untouched by a label rename).
 *
 * Every UI surface that shows a taxonomy chip, a "Set category" option, or
 * a taxonomy breakdown count MUST import from here, never hardcode a label
 * inline -- CLAUDE.md bug class #4 (hand-maintained list drift): the same
 * label previously existed as three independent hardcodes (InvoicesPage.jsx
 * chips, InvoicesPage.jsx Set-category menu, and nowhere for the census
 * panels at all, which rendered the raw snake_case key unlabeled).
 */

export const SUPPLIER_TAXONOMY_CATEGORIES = [
  { key: 'br_os_suppliers', label: 'BR OS Supplier' },
  { key: 'property_portfolio', label: 'Property Portfolio' },
  { key: 'operations', label: 'Operations' },
  { key: 'government_tax', label: 'Government & Tax' },
  { key: 'receipts', label: 'Receipts' },
  { key: 'unclassified', label: 'Unclassified' },
];

export const CLIENT_TAXONOMY_CATEGORIES = [
  { key: 'br_os_clients', label: 'BR OS Clients' },
  { key: 'property_portfolio', label: 'Property Portfolio' },
  { key: 'management_statements', label: 'Mgmt statement' },
  { key: 'unclassified', label: 'Unclassified' },
];

function toLabelMap(categories) {
  return Object.fromEntries(categories.map((c) => [c.key, c.label]));
}

export const SUPPLIER_TAXONOMY_LABELS = toLabelMap(SUPPLIER_TAXONOMY_CATEGORIES);
export const CLIENT_TAXONOMY_LABELS = toLabelMap(CLIENT_TAXONOMY_CATEGORIES);

// Combined lookup for surfaces (e.g. census panels) that render a taxonomy
// breakdown without already knowing which tab/direction it came from --
// both key sets are disjoint except for the shared 'property_portfolio'/
// 'unclassified' keys, which resolve identically either way.
export const TAXONOMY_LABELS = { ...SUPPLIER_TAXONOMY_LABELS, ...CLIENT_TAXONOMY_LABELS };

export function taxonomyLabel(key) {
  return TAXONOMY_LABELS[key] || key;
}
